$(document).ready(function () {

jQuery(document).on('click', '.cloud_search_filters_btn_mobile .button', function() {
  jQuery('.cloud_search_filters_sidebar_mobile').toggleClass('active_mobile');
  jQuery('.main-collection').toggleClass('active_mobile_filter');
  jQuery('body').toggleClass('active_mobile_body');
});

jQuery(document).on('click', '.cloud_search_filters_sidebar_mobile_close', function() {
  jQuery('.cloud_search_filters_sidebar_mobile').removeClass('active_mobile');
  jQuery('.main-collection').removeClass('active_mobile_filter');
  jQuery('body').removeClass('active_mobile_body');
});

jQuery('section#shopify-section-template--17614196408401__rich_text_waKDRL a.button.button--secondary').on('click', function(e) {
    e.preventDefault();
    jQuery('.home-moretext').toggle();

    // Toggle the button text
    var btn = jQuery(this);
    if (btn.text().trim() === "Read More") {
        btn.text("Read Less");
    } else {
        btn.text("Read More");
    }
});

  $('.btn_cart_open').on('click', function(e){
    e.preventDefault();
    $('.header-main .header-icons modal-opener').trigger('click');
})
  
$('header#Page-Header ul.mega-menu-list ul.list-menu').hide();

$('header#Page-Header .mega-menu-item').each(function() {
  var $this = $(this);
  var $submenu = $this.find('ul.list-menu');
  var $heading = $this.find('h3');
  var $linkText = $heading.find('a.link-text');

  // If submenu exists, add dropdown icon and bind toggle to both link and icon
  if ($submenu.length > 0) {
    var $dropdownIcon = $(`
      <span class="dropdown-toggle" style="cursor:pointer; margin-left:5px; display:inline-block; transition: transform 0.3s;">
        <svg class="icon icon-caret" width="14" height="14" viewBox="0 -10 36 36" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 17.5505L25.6941 5L28 7.47475L16.3059 20.0253L14 22.5L11.6941 20.0253L0 7.47475L2.30588 5L14 17.5505Z" fill="currentColor"></path>
        </svg>
      </span>
    `);
    $heading.append($dropdownIcon);

    // Define a toggle function so both elements can use it
    const toggleDropdown = function(e) {
      e.preventDefault();
      e.stopPropagation();

      $submenu.slideToggle();
      $dropdownIcon.toggleClass('active');

      if ($dropdownIcon.hasClass('active')) {
        $dropdownIcon.css('transform', 'rotate(180deg)');
      } else {
        $dropdownIcon.css('transform', 'rotate(0deg)');
      }
    };

    // Attach to both link text and dropdown icon
    $linkText.on('click', toggleDropdown);
    $dropdownIcon.on('click', toggleDropdown);
  }
});


  

  
    $(".faq-answer").hide();

    $(".faq-question").on("click", function () {
      const isActive = $(this).hasClass("active");

      // Reset all
      $(".faq-question").removeClass("active").find(".icon").text("+");
      $(".faq-answer").slideUp(200);

      if (!isActive) {
        $(this).addClass("active").find(".icon").text("-");
        $(this).next(".faq-answer").slideDown(200);
      }
    });

    // Add icon spans
    $(".faq-question").each(function () {
      $(this).append('<span class="icon">+</span>');
    });


  $('section#shopify-section-template--17614196408401__logo_list_4yTrpA .logo-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 1000,
    speed: 7000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px',
        }
      },
    ]
  });

jQuery('#Header-Menu-Drawer').on('click', '.menu-summary a', function(e) {
  // Only apply on mobile devices (width <= 768px)
  if (window.innerWidth <= 768) {
    const $summary = jQuery(this).closest('summary');
    const $details = $summary.parent('details');
    const $submenuUL = $details.find('> .menu-drawer-submenu > .submenu-wrapper > ul.menu-drawer-menu');

    if ($submenuUL.length > 0 && $submenuUL.children().length > 0) {
      e.preventDefault(); // block the <a> click

      const isOpen = $details.prop('open');
      $details.prop('open', !isOpen);
      $summary.attr('aria-expanded', !isOpen);
    }
    // else: allow normal <a> click
  }
  // else: allow normal <a> click on desktop
});

  
  });

//  equal heighty 
function setEqualHeight() {
  const selectors = [
    '.card-wrapper.product-card-wrapper .card .card-content .card-price',
    '.card-wrapper .card .card-content .card-heading a'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    let maxHeight = 0;

    // Reset heights
    elements.forEach(el => el.style.height = 'auto');

    // Calculate max height
    elements.forEach(el => {
      if (el.offsetHeight > maxHeight) {
        maxHeight = el.offsetHeight;
      }
    });

    // Set max height
    elements.forEach(el => el.style.height = maxHeight + 'px');
  });
}

window.addEventListener('load', setEqualHeight);
window.addEventListener('resize', setEqualHeight);







